import { ADMIN_API_BASE } from "./adminApiConfig";
import adminRequest from "./adminRequest";

export interface AdminStats {
  totalCodes: number;
  uniquePlayers: number;
  codesToday: number;
  playersToday: number;
}

export interface AdminStatsResponse {
  code: number;
  message: string;
  data: AdminStats | null;
}

const getAdminStats = async (): Promise<AdminStatsResponse> => {
  try {
    return await adminRequest<AdminStatsResponse>({
      method: "GET",
      url: `${ADMIN_API_BASE}/api/admin/stats`,
    });
  } catch (error) {
    return { code: 500, message: "Greška", data: null };
  }
};

export default getAdminStats;
